import React from "react";
import { Helmet } from "react-helmet-async";

import Banner from "components/pages/Promotion/Banner";
import Benefit from "components/pages/Promotion/Benefit";
import Stack from "@mui/material/Stack";
import { promo } from "types";

function Image({ index, imgSrc, alt }) {
  const even = index % 2 === 0;
  const color = even
    ? "#37b995" // primary.main
    : "#f37820"; // secondary.main

  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          position: "absolute",
          top: -25,
          left: -25,
          width: 50,
          height: 50,
          borderRadius: "50%",
          backgroundColor: color,
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 30,
        }}
      >
        {index + 1}
      </div>
      <div
        style={{
          position: "absolute",
          width: 350,
          height: 250,
          borderRadius: 30,
          border: `2px dashed ${color}`,
          transform: `rotate(${even ? -5 : 5}deg)`,
        }}
      />
      <img
        src={imgSrc}
        alt={alt}
        loading="lazy"
        width={350}
        height={250}
        style={{ borderRadius: 30 }}
      />
    </div>
  );
}

function Promotion({ promo }) {
  const {
    title,
    path,
    bannerBgColor,
    bannerImgUrl,
    bannerHeader,
    bannerText,
    buttonColor,
    actionText,
    benefit1ImgSrc,
    benefit1Header,
    benefit1Text,
    benefit2ImgSrc,
    benefit2Header,
    benefit2Text,
    benefit3ImgSrc,
    benefit3Header,
    benefit3Text,
    benefit4ImgSrc,
    benefit4Header,
    benefit4Text,
    benefit5ImgSrc,
    benefit5Header,
    benefit5Text,
  } = promo[0];

  if (
    !title ||
    !path ||
    !bannerBgColor ||
    !bannerImgUrl ||
    !bannerHeader ||
    !bannerText ||
    !buttonColor ||
    !actionText
  ) {
    return null;
  }

  const benefits = [
    ...(benefit1ImgSrc && benefit1Header && benefit1Text
      ? [{ imgSrc: benefit1ImgSrc, header: benefit1Header, text: benefit1Text }]
      : []),
    ...(benefit2ImgSrc && benefit2Header && benefit2Text
      ? [{ imgSrc: benefit2ImgSrc, header: benefit2Header, text: benefit2Text }]
      : []),
    ...(benefit3ImgSrc && benefit3Header && benefit3Text
      ? [{ imgSrc: benefit3ImgSrc, header: benefit3Header, text: benefit3Text }]
      : []),
    ...(benefit4ImgSrc && benefit4Header && benefit4Text
      ? [{ imgSrc: benefit4ImgSrc, header: benefit4Header, text: benefit4Text }]
      : []),
    ...(benefit5ImgSrc && benefit5Header && benefit5Text
      ? [{ imgSrc: benefit5ImgSrc, header: benefit5Header, text: benefit5Text }]
      : []),
  ];

  return (
    <Stack spacing={10}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={bannerHeader} />
        <link
          rel="canonical"
          href={`https://englishtree.edu.vn/tin-tuc/${path}`}
        />
      </Helmet>

      <Banner
        bannerBgColor={bannerBgColor}
        bannerImgUrl={bannerImgUrl}
        bannerHeader={bannerHeader}
        bannerText={bannerText}
        buttonColor={buttonColor}
        actionText={actionText}
      />

      {benefits.map(({ imgSrc, header, text }, index) => (
        <Benefit
          key={header}
          index={index}
          img={<Image index={index} imgSrc={imgSrc} alt={header} />}
          header={header}
          text={text}
        />
      ))}
    </Stack>
  );
}

Promotion.propTypes = {
  promo: promo,
};

export default Promotion;
